import React, { useEffect, useState } from 'react';
import apiService from '../../utils/apiService';
import { useSelector, useDispatch } from 'react-redux';
import { setEmailSub } from '../../redux/userSlice';
import { Switch } from '@headlessui/react';
import { PrimaryBtn, SecondaryBtn } from '../Assets/Buttons';

const Notifications = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const emailSub = useSelector((state) => state.user.emailSub);
    const [emailStatus, setEmailStatus] = useState(emailSub);
    const [emailSubChange, setEmailSubChange] = useState(false);

    useEffect(() => {
        if (emailStatus !== emailSub) {
            setEmailSubChange(true);
        } else {
            setEmailSubChange(false);
        }
    }, [emailStatus]);

    const handleCancel = () => {
        setEmailStatus(emailSub);
        setEmailSubChange(false);
    };

    const updateEmailNotifications = async (type) => {
        try {
            // Subscribe user to email notifications
            if (type === "sub") {

                let payload = await apiService('app/subscribe-email');
                if (payload.message === "Email subscription updated") {
                    dispatch(setEmailSub(true));
                    setError(null);
                } else {
                    setError(payload.message);
                    setEmailStatus(emailSub);
                }
            // Unsubscribe user to email notifications
            } else {
                let payload = await apiService('app/unsub-email');
                if (payload.message === "Email subscription updated") {
                    dispatch(setEmailSub(false));
                    setError(null);
                } else {
                    setError(payload.message);
                    setEmailStatus(emailSub);
                }
            }
        } catch (error) {
            console.log(error);
            setEmailStatus(emailSub);
            setError("Something went wrong, please try again later");
        }

        setEmailSubChange(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (emailStatus === true) {
            updateEmailNotifications("sub");
        } else {
            updateEmailNotifications("unsub");
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="rounded-lg overflow-hidden">
                <div className="bg-gray-50 dark:bg-brand-dark-700 px-4 py-3 border-b border-gray-200 dark:border-brand-dark-600">
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                        Notifications
                    </h3>
                </div>
                <div className="bg-white dark:bg-brand-dark-800 px-4 py-5 space-y-4">
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-700 dark:text-gray-300">Email Notifications</span>
                        <Switch
                            checked={emailStatus}
                            onChange={setEmailStatus}
                            className={`${
                                emailStatus ? 'bg-brand-red-500' : 'bg-gray-200 dark:bg-gray-700'
                            } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-brand-red-400 focus:ring-offset-2`}
                        >
                            <span
                                className={`${
                                    emailStatus ? 'translate-x-6' : 'translate-x-1'
                                } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                            />
                        </Switch>
                    </div>
                    
                    {error && (
                        <p className="text-sm text-brand-red-500 dark:text-brand-red-400">
                            {error}
                        </p>
                    )}
                    
                    {emailSubChange && (
                        <div className="flex space-x-3 pt-3">
                            <SecondaryBtn
                                text="Cancel"
                                onClick={handleCancel}
                            />
                            <PrimaryBtn
                                text="Save Changes"
                                type="submit"
                            />
                        </div>
                    )}
                </div>
            </div>
        </form>
    );
};

export default Notifications;